import { MaterialLayoutRenderer } from '@jsonforms/material-renderers';
import { rankWith, uiTypeIs } from '@jsonforms/core';
import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import './FieldsetDirectionColumn.css';
import { useResponsive } from '../../../services/hooks';

const FieldsetDirectionColumnRenderer = props => {
  const { uischema, schema, path, visible, renderers, enabled } = props;

  const layoutProps = {
    elements: uischema.elements,
    schema,
    path,
    direction: 'column',
    visible,
    uischema,
    renderers,
    enabled
  };

  return (
    <div className="fieldset-direction-column">
      <MaterialLayoutRenderer {...layoutProps} />
    </div>
  );
};

export default withJsonFormsLayoutProps(FieldsetDirectionColumnRenderer);

export const FieldsetDirectionColumnTester = rankWith(1000, uiTypeIs('FieldsetDirectionColumn'));
